

const localAccessors = {
  // Posts local state
  nearbyFeed: () => 'nearby-feed_posts',
  followingFeed: () => 'following-feed_posts',
  forYouFeed: () => 'for-you-feed_posts',
  postShow: (postUuid) => `post-show-main_post-${postUuid}`,
  postShowReplies: (postUuid) => `post-show-replies_posts-${postUuid}`,
  notificationsPostList: () => 'notifications-post-list_posts',
  nearbyProfilePosts: (userUuid) => `nearby-profile-posts-${userUuid}`,
  socialProfileNormalPosts: (userUuid) => `social-profile-normal-posts-${userUuid}`,
  socialProfileRepostPosts: (userUuid) => `social-profile-repost-posts-${userUuid}`,
  socialProfileRepliesPosts: (userUuid) => `social-profile-replies-posts-${userUuid}`,
  socialProfileMediaPosts: (userUuid) => `social-profile-media-posts-${userUuid}`,
}

const setSessionState = (accessor, data) =>{
  try {
    sessionStorage.setItem(accessor, JSON.stringify(data))
  } catch (err) {
    console.log(err)
  }
}

const setLocalState = (accessor, data) =>{
  try {
    localStorage.setItem(accessor, JSON.stringify(data))
  } catch (err) {
    console.log(err)
  }
}

const setPostShowSessionState = (postUuid, data) => {
  setSessionState(localAccessors.postShow(postUuid), data)
}

export {
  localAccessors,
  setSessionState,
  setLocalState,
  setPostShowSessionState,
}